import { FormInputRow } from '@emerald-works-nova/components'
import { Grid } from '@mui/material'
import React from 'react'
import { BannerStatic } from '../../../components'
import { useCampaignFormContext } from '../campaign-form-context'
import { InputLogo } from '../components'
import { useStyles } from './style'

const ImagesTab = () => {
  const classes = useStyles()
  const { form, setCurrentTabValidation } = useCampaignFormContext()

  const [rectangularImg, squareImg] = form.watch(['rectangularImg', 'squareImg'])
  React.useEffect(() => {
    setCurrentTabValidation(() => () => {
      const result = !!rectangularImg && !!squareImg
      !result && BannerStatic.show({ label: 'The images are required', isError: true })
      return result
    })
  }, [setCurrentTabValidation, rectangularImg, squareImg])

  return (
    <Grid className={classes.root}>
      <Grid item xs={12}>
        <FormInputRow
          title='Horizontal image'
          description='Aspect Ratio 16:9. This image will be used for the Homepage Banner and eventual future pieces that fit in a horizontal format.'
          smallFormTitles
          InputComponent={<InputLogo name='rectangularImg' {...form} />}
        />
      </Grid>
      <Grid item xs={12}>
        <FormInputRow
          title='Square image'
          description='Aspect Ratio 1:1. This image will be used for the banners in following positions: navigation menu, category page, article page vertical and article page horizontal.'
          smallFormTitles
          InputComponent={<InputLogo name='squareImg' {...form} />}
        />
      </Grid>
    </Grid>
  )
}

export default ImagesTab
